import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UpdateTransaciton } from 'app/dtos/Transaction/updateTransaction';
import { UpdateTransacitonExpense } from 'app/dtos/Transaction/updateTransactionExpense';
import { _isId } from 'app/services/auth.service';
import { ExpenseService } from 'app/services/models/expense.service';
import { ProjectService } from 'app/services/models/project.service';
import { TaxService } from 'app/services/models/tax.service';
import { TransactionService } from 'app/services/models/transaction.service';
import { VaultService } from 'app/services/models/vault.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-expense-transaction-update',
  templateUrl: './expense-transaction-update.component.html',
  styleUrls: ['./expense-transaction-update.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExpenseTransactionUpdateComponent implements OnInit {
  public contentHeader;


  date = new Date();
  public basicDateOptions: FlatpickrOptions = {
    altInput: true,
    locale: Turkish,
  }

  expenseTransactionForm: FormGroup

  transaction: any

  expenses: any[] = [];
  projects: any[] = [];
  taxes: any[] = [];
  vaults: any[] = [];

  constructor(
    private activadetRouter: ActivatedRoute,
    private transactionService: TransactionService,
    private formBuilder: FormBuilder,
    private projectService: ProjectService,
    private taxexService: TaxService,
    private expenseService: ExpenseService,
    private toastService: ToastrService,
    private router: Router,
    private vaultSerivce: VaultService,
    private cdr: ChangeDetectorRef) {

    this.expenseTransactionForm = this.formBuilder.group({
      project: [null],
      expense: [null, [Validators.required]],
      transactionDate: [this.date, [Validators.required]],
      documentNo: [null],
      totalAmount: [null, Validators.required],
      taxRate: [null, Validators.required],
      description: [null],
      vaultId: []
    });
  }

  initialSalePrice: number | null = null; // İlk değeri saklamak için
  previousSalePrice: number | null = null; // Son değeri saklamak için
  priceChanged: boolean = false;

  async ngOnInit() {
    this.activadetRouter.params.subscribe(params => {
      this.getByIdTransactionExpense(params['id']);
    })

    this.expenseTransactionForm.get('totalAmount')?.valueChanges.subscribe(() => {
      const currentSalePrice = this.expenseTransactionForm.value.totalAmount;

      // İlk değer gelirse sakla ve bir daha değiştirme
      if (this.initialSalePrice === null) {
        this.initialSalePrice = currentSalePrice;
      }



      // Son değişen değeri güncelle ve değişim durumunu kontrol et
      this.priceChanged = currentSalePrice !== this.previousSalePrice;
      this.previousSalePrice = currentSalePrice;
      this.expenseTransactionForm.patchValue({
        vaultId: this.vaults[0]?.id
      })

      console.log('Initial:', this.initialSalePrice);
      console.log('Previous:', this.previousSalePrice);
      console.log('Current:', currentSalePrice);
    });

    this.contentHeader = {
      headerTitle: 'Masraflar',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Masraf Listesi',
            isLink: true,
            link: '/admin/mexpensetransaction'
          },
          {
            name: 'Masraf Güncelle',
            isLink: false,
          },
        ]
      }
    }

    await this.getAllProject();
    await this.getAllKdv();
    await this.getAllExpense();
    await this.getAllVault();
  }

  async getAllVault() {
    const data = await this.vaultSerivce.getAllVault(0, 100, '');
    console.log(data);
    this.vaults = data.vaults;
  }

  async getByIdTransactionExpense(id) {
    const data = await this.transactionService.getByIdTransaction(id);
    console.log(data);
    this.transaction = data;

    if (data != null) {
      this.date = new Date(data.transactionCraetedAt)
      this.expenseTransactionForm.patchValue({
        project: data.project[0]?.id,
        expense: data.expenseTransaction[0].expenseId,
        documentNo: data?.docNo ?? null,
        transactionDate: this.date,
        totalAmount: data.transactionManagementProducts[0].productPrice,
        taxRate: data.transactionManagementProducts[0].taxId,
        description: data.transactionPrivateNode
      })

    }
  }

  async onSubmit() {
    if (this.expenseTransactionForm.valid) {
      console.log(this.expenseTransactionForm.value);
      const date = new Date(this.expenseTransactionForm.value.transactionDate).setHours(3);
      const date2 = new Date(date);
      const expenseDto = new UpdateTransacitonExpense();
      expenseDto.id = this.transaction.id
      expenseDto.description = this.expenseTransactionForm.value.description;
      expenseDto.docNo = this.expenseTransactionForm.value.documentNo  == "" ? null : this.expenseTransactionForm.value.documentNo;
      expenseDto.expenseId = this.expenseTransactionForm.value.expense;
      expenseDto.expenseTransactionId = this.transaction.expenseTransaction[0].id
      expenseDto.projectId = this.expenseTransactionForm.value.project;
      expenseDto.taxId = this.expenseTransactionForm.value.taxRate;
      expenseDto.salePrice = this.expenseTransactionForm.value.totalAmount;
      expenseDto.transactionManagementProductId = this.transaction.transactionManagementProducts[0].transactionManagemetnProductId;
      expenseDto.date = date2;
      console.log('Initial:', this.initialSalePrice);
      console.log(expenseDto.salePrice);

      const response = await this.transactionService.UpdateDetailTransactionMagenemntExpense(expenseDto);
      if (response.status) {
        if (this.initialSalePrice && expenseDto.salePrice > this.initialSalePrice) {
          console.log("değer büyüdü");
          const price = +(expenseDto.salePrice - this.initialSalePrice).toFixed(2);
          await this.vaultSerivce.createCompanyVaultMovement(
            this.expenseTransactionForm.value.vaultId,
            price,
             15,
            _isId,
            1,
            `${expenseDto.docNo ?? null + expenseDto.description ?? null}`,
            expenseDto.projectId)
        } else if (this.initialSalePrice && expenseDto.salePrice < this.initialSalePrice) {
          const price = +(this.initialSalePrice - expenseDto.salePrice).toFixed(2);
          await this.vaultSerivce.createCompanyVaultMovement(
            this.expenseTransactionForm.value.vaultId,
            price,
            13,
            _isId,
            1,
            `${expenseDto.docNo ?? null + expenseDto.description ?? null}`,
            expenseDto.projectId)
        } else {
          console.log("işlem yok");
        }
        this.transactionService.sendEvent(true);
        this.toastService.success(response.message);
      } else {
        this.toastService.error(response.message);
      }
    }
  }



  async getAllExpense() {
    const data = await this.expenseService.getExpense();
    console.log(data);
    this.expenses = data.map(expense => ({
      id: expense.id,
      name: expense.name,
      mainExpenseName: expense.mainExpenseName
    })
    );
  }

  async getAllProject() {
    const data = await this.projectService.getAllProject(0, 100, '');
    this.projects = data.projects.map(project => ({
      id: project.id,
      name: project.name
    }));
  }

  async getAllKdv() {
    const data = await this.taxexService.getAllTax(0, 100, '');
    this.taxes = data.taxex.map(tax => ({
      id: tax.id,
      taxRate: `${tax.taxRate}%`
    }));
  }
}